module.exports = __webpack_public_path__ + "static/media/largeMedal_2.f3778049.png";